import { useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';
import { ROLES_KEY } from './useRoles.js';

export function useCreateRole() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/roles', body).then((r) => r.data),
    successMessage: 'تم إنشاء الدور',
    onSuccess: () => qc.invalidateQueries({ queryKey: ROLES_KEY })
  });
}

export function useUpdateRole() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.patch(`/roles/${id}`, body).then((r) => r.data),
    successMessage: 'تم حفظ الدور',
    onSuccess: () => qc.invalidateQueries({ queryKey: ROLES_KEY })
  });
}

export function useDeleteRole() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (id) => api.delete(`/roles/${id}`).then((r) => r.data),
    successMessage: 'تم حذف الدور',
    onSuccess: () => qc.invalidateQueries({ queryKey: ROLES_KEY })
  });
}

export function useUpdateRolePermissions() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, permissions }) =>
      api.put(`/roles/${id}/permissions`, { permissions }).then((r) => r.data),
    successMessage: 'تم حفظ الصلاحيات',
    onSuccess: () => qc.invalidateQueries({ queryKey: ROLES_KEY })
  });
}
